// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chat-popup-toggle {
  position: fixed;
  right: 20px;
  bottom: 20px;
  width: 48px;
  height: 48px;
  background: #007bff;
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 2000;
  box-shadow: 0 4px 12px rgba(0,0,0,0.15);
}

.chat-popup-toggle .unread-badge {
  position: absolute;
  top: -6px;
  right: -6px;
  background: #dc3545;
  color: white;
  font-size: 11px;
  padding: 2px 6px;
  border-radius: 12px;
}

.chat-window {
  position: fixed;
  right: 20px;
  bottom: 80px;
  width: 320px;
  max-height: 420px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(0,0,0,0.15);
  z-index: 2000;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.chat-header {
  display:flex;
  align-items:center;
  justify-content:space-between;
  padding:8px 12px;
  background:#f5f5f5;
  border-bottom:1px solid #eee;
}

.chat-close {
  width:28px;
  height:28px;
  display:inline-flex;
  align-items:center;
  justify-content:center;
  border-radius:50%;
  border: none;
  background: transparent;
  color: #333;
  cursor: pointer;
  font-size:14px;
  line-height:1;
  transition: background 120ms ease, color 120ms ease, transform 120ms ease;
}
.chat-close:hover {
  background: rgba(0,0,0,0.06);
  color: #000;
  transform: translateY(-1px);
}
.chat-close:active {
  transform: translateY(0);
}

.chat-body {
  padding:8px;
  overflow:auto;
  flex:1 1;
  background: #fafafa;
}

.chat-message { margin:6px 0; }
.chat-message.me { text-align: right; }
.chat-message .content { display:inline-block; padding:8px 10px; border-radius:12px; max-width:80%; }
.chat-message.me .content { background:#007bff; color:white; }
.chat-message.them .content { background:#eee; color:#222; }

.typing { padding:6px 8px; color:#666 }

.chat-input { display:flex; padding:8px; gap:8px; border-top:1px solid #eee }
.chat-input input { flex:1 1; padding:8px; border-radius:6px; border:1px solid #ddd }
.chat-input button { background:#007bff; color:white; border:none; padding:8px 12px; border-radius:6px }

/* Dark mode overrides when the top-level app has the \`dark\` class */
.app.dark .chat-popup-toggle {
  background: #1f2937;
  color: #f8fafc;
  box-shadow: 0 6px 20px rgba(0,0,0,0.5);
}
.app.dark .chat-popup-toggle .unread-badge {
  background: #ef4444;
  color: #fff;
}
.app.dark .chat-window {
  background: #0b1220;
  box-shadow: 0 12px 32px rgba(0,0,0,0.6);
}
.app.dark .chat-header { background: #071025; border-bottom-color: rgba(255,255,255,0.04); color: #e6eef6 }
.app.dark .chat-body { background: #071025; color: #e6eef6 }
.app.dark .chat-message .content { color: #e6eef6 }
.app.dark .chat-message.me .content { background: #0b84ff; color: white }
.app.dark .chat-message.them .content { background: #0f1724; color: #cbd5e1 }
.app.dark .chat-input { border-top-color: rgba(255,255,255,0.04); }
.app.dark .chat-input input { background: #071025; color: #e6eef6; border-color: rgba(255,255,255,0.04) }
.app.dark .chat-input button { background:#0b84ff }
.app.dark .chat-close { color: #cbd5e1 }
.app.dark .chat-close:hover { background: rgba(255,255,255,0.03); color: #fff }
`, "",{"version":3,"sources":["webpack://./src/components/Chat/Chat.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,aAAa;EACb,uCAAuC;AACzC;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,uCAAuC;EACvC,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;EAC7B,gBAAgB;EAChB,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;EACtB,iBAAiB;EACjB,YAAY;EACZ,uBAAuB;EACvB,WAAW;EACX,eAAe;EACf,cAAc;EACd,aAAa;EACb,yEAAyE;AAC3E;AACA;EACE,4BAA4B;EAC5B,WAAW;EACX,2BAA2B;AAC7B;AACA;EACE,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,aAAa;EACb,QAAM;EACN,mBAAmB;AACrB;;AAEA,gBAAgB,YAAY,EAAE;AAC9B,mBAAmB,iBAAiB,EAAE;AACtC,yBAAyB,oBAAoB,EAAE,gBAAgB,EAAE,kBAAkB,EAAE,aAAa,EAAE;AACpG,4BAA4B,kBAAkB,EAAE,WAAW,EAAE;AAC7D,8BAA8B,eAAe,EAAE,UAAU,EAAE;;AAE3D,UAAU,eAAe,EAAE,WAAW;;AAEtC,cAAc,YAAY,EAAE,WAAW,EAAE,OAAO,EAAE,0BAA0B;AAC5E,oBAAoB,QAAM,EAAE,WAAW,EAAE,iBAAiB,EAAE,sBAAsB;AAClF,qBAAqB,kBAAkB,EAAE,WAAW,EAAE,WAAW,EAAE,gBAAgB,EAAE,kBAAkB;;AAEvG,oEAAoE;AACpE;EACE,mBAAmB;EACnB,cAAc;EACd,sCAAsC;AACxC;AACA;EACE,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,uCAAuC;AACzC;AACA,yBAAyB,mBAAmB,EAAE,2CAA2C,EAAE,eAAe;AAC1G,uBAAuB,mBAAmB,EAAE,eAAe;AAC3D,mCAAmC,eAAe;AAClD,sCAAsC,mBAAmB,EAAE,aAAa;AACxE,wCAAwC,mBAAmB,EAAE,eAAe;AAC5E,wBAAwB,wCAAwC,EAAE;AAClE,8BAA8B,mBAAmB,EAAE,cAAc,EAAE,qCAAqC;AACxG,+BAA+B,mBAAmB;AAClD,wBAAwB,eAAe;AACvC,8BAA8B,kCAAkC,EAAE,YAAY","sourcesContent":[".chat-popup-toggle {\r\n  position: fixed;\r\n  right: 20px;\r\n  bottom: 20px;\r\n  width: 48px;\r\n  height: 48px;\r\n  background: #007bff;\r\n  color: white;\r\n  border-radius: 50%;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  cursor: pointer;\r\n  z-index: 2000;\r\n  box-shadow: 0 4px 12px rgba(0,0,0,0.15);\r\n}\r\n\r\n.chat-popup-toggle .unread-badge {\r\n  position: absolute;\r\n  top: -6px;\r\n  right: -6px;\r\n  background: #dc3545;\r\n  color: white;\r\n  font-size: 11px;\r\n  padding: 2px 6px;\r\n  border-radius: 12px;\r\n}\r\n\r\n.chat-window {\r\n  position: fixed;\r\n  right: 20px;\r\n  bottom: 80px;\r\n  width: 320px;\r\n  max-height: 420px;\r\n  background: #fff;\r\n  border-radius: 8px;\r\n  box-shadow: 0 8px 24px rgba(0,0,0,0.15);\r\n  z-index: 2000;\r\n  display: flex;\r\n  flex-direction: column;\r\n  overflow: hidden;\r\n}\r\n\r\n.chat-header {\r\n  display:flex;\r\n  align-items:center;\r\n  justify-content:space-between;\r\n  padding:8px 12px;\r\n  background:#f5f5f5;\r\n  border-bottom:1px solid #eee;\r\n}\r\n\r\n.chat-close {\r\n  width:28px;\r\n  height:28px;\r\n  display:inline-flex;\r\n  align-items:center;\r\n  justify-content:center;\r\n  border-radius:50%;\r\n  border: none;\r\n  background: transparent;\r\n  color: #333;\r\n  cursor: pointer;\r\n  font-size:14px;\r\n  line-height:1;\r\n  transition: background 120ms ease, color 120ms ease, transform 120ms ease;\r\n}\r\n.chat-close:hover {\r\n  background: rgba(0,0,0,0.06);\r\n  color: #000;\r\n  transform: translateY(-1px);\r\n}\r\n.chat-close:active {\r\n  transform: translateY(0);\r\n}\r\n\r\n.chat-body {\r\n  padding:8px;\r\n  overflow:auto;\r\n  flex:1;\r\n  background: #fafafa;\r\n}\r\n\r\n.chat-message { margin:6px 0; }\r\n.chat-message.me { text-align: right; }\r\n.chat-message .content { display:inline-block; padding:8px 10px; border-radius:12px; max-width:80%; }\r\n.chat-message.me .content { background:#007bff; color:white; }\r\n.chat-message.them .content { background:#eee; color:#222; }\r\n\r\n.typing { padding:6px 8px; color:#666 }\r\n\r\n.chat-input { display:flex; padding:8px; gap:8px; border-top:1px solid #eee }\r\n.chat-input input { flex:1; padding:8px; border-radius:6px; border:1px solid #ddd }\r\n.chat-input button { background:#007bff; color:white; border:none; padding:8px 12px; border-radius:6px }\r\n\r\n/* Dark mode overrides when the top-level app has the `dark` class */\r\n.app.dark .chat-popup-toggle {\r\n  background: #1f2937;\r\n  color: #f8fafc;\r\n  box-shadow: 0 6px 20px rgba(0,0,0,0.5);\r\n}\r\n.app.dark .chat-popup-toggle .unread-badge {\r\n  background: #ef4444;\r\n  color: #fff;\r\n}\r\n.app.dark .chat-window {\r\n  background: #0b1220;\r\n  box-shadow: 0 12px 32px rgba(0,0,0,0.6);\r\n}\r\n.app.dark .chat-header { background: #071025; border-bottom-color: rgba(255,255,255,0.04); color: #e6eef6 }\r\n.app.dark .chat-body { background: #071025; color: #e6eef6 }\r\n.app.dark .chat-message .content { color: #e6eef6 }\r\n.app.dark .chat-message.me .content { background: #0b84ff; color: white }\r\n.app.dark .chat-message.them .content { background: #0f1724; color: #cbd5e1 }\r\n.app.dark .chat-input { border-top-color: rgba(255,255,255,0.04); }\r\n.app.dark .chat-input input { background: #071025; color: #e6eef6; border-color: rgba(255,255,255,0.04) }\r\n.app.dark .chat-input button { background:#0b84ff }\r\n.app.dark .chat-close { color: #cbd5e1 }\r\n.app.dark .chat-close:hover { background: rgba(255,255,255,0.03); color: #fff }\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
